// extracted by mini-css-extract-plugin
export default {"LabelText":"SwitchInput_LabelText__C-rx2","LabelDescriptionText":"SwitchInput_LabelDescriptionText__IM0g-"};